/* 🤖 this file was generated by svg-to-ts */
export const fthrX: {
    name: 'fthr-x';
    data: string;
} = {
    name: 'fthr-x',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-x" viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>`,
};
